import { useMutation } from '@tanstack/react-query';
import { expressMutation } from '../../../../repository/react-query/useExpress';
import { extractS3InfoFromSignedURL } from '../../../../../utils';

const uploadFiles = ({ formData, setUploadProgress }) => {
    return expressMutation({
        method: 'POST',
        endpoint: '/s3/file-upload',
        body: formData,
        options: {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (progressEvent) => {
                const progress = progressEvent.total ? Math.round((progressEvent.loaded * 100) / progressEvent.total) : 0;
                setUploadProgress(progress);
            },
        },
    });
};

export const useUploadFiles = () => {
    return useMutation({ mutationFn: uploadFiles });
};

const getSignedUrl = ({ url }) => {
    const decodedUrl = decodeURIComponent(url);
    const { bucketPath, filePath, baseFileName } = extractS3InfoFromSignedURL(decodedUrl);
    return expressMutation({
        method: 'POST',
        endpoint: '/s3/get-signed-url',
        body: {
            bucketPath,
            filePath,
            fileNameOnDownload: baseFileName,
        },
    });
};

export const useGetSignedUrl = () => {
    return useMutation({ mutationFn: getSignedUrl });
};
